import React from 'react'
import customTheme from '../utils/ui'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from "@mui/styles";
import Typography from '@mui/material/Typography';
import firebase from "firebase";
import { useHistory, useParams } from 'react-router-dom';
import { setFavouriteProducts } from "../redux/reducers/favouriteProducts.reducer";
import { setNotifications, setNotificationsProducts } from "../redux/reducers/notificationsProducts.reducer";
import { setSelectedEmirates, setSelectedRegion } from "../redux/reducers/emiratesAndRegion.reducer";
import { setSelectedStores } from "../redux/reducers/stores.reducer";
import { logoutSuccess } from "../redux/reducers/auth.reducer";
import { Grid, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

const useStyles = makeStyles({
    bar: {
        backgroundColor: customTheme.light.primary,
        paddingTop: 10,
        paddingBottom: 10,
        marginTop: 40,
        marginLeft: 10,
        width: "100%",
        display: 'flex',
        justifyContent: 'center',
        cursor: "pointer",
        borderStyle: "solid",
        borderWidth: 0,
        borderRadius: 50,
        alignSelf: "center",
        alignItems: 'center'
    },
    text: {
        color: customTheme.light.white,
        fontWeight: 'bold',
        cursor: "pointer",
        textAlign: "center",
        justifyContent: 'center',
        fontSize: 13
    }
})


const CompleteProfileHint = ({ isDrawerOpen }) => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const styles = useStyles();
    const history = useHistory();
    const userData = useSelector((state) => state.auth.user);
    const theme = useTheme();
    const xsDown = useMediaQuery(theme.breakpoints.up('xs'));
    const handleCompleteProfile = () => {
        history.push('/profile');
    }
    const handleLogout = async () => {
        await firebase.auth().signOut();
        dispatch(logoutSuccess());
        dispatch(setFavouriteProducts([]));
        dispatch(setSelectedEmirates([]));
        dispatch(setSelectedRegion([]));
        dispatch(setNotificationsProducts([]));
        dispatch(setNotifications([]));
        dispatch(setSelectedStores([]));
    };
    return (<>
        {xsDown && !userData?.isAnonymous && (!userData || !userData.nationality || !userData.fullName || !userData.gender || !userData.phone) && <div style={{ height: "50px" }} />}       
        {userData?.isAnonymous && <div onClick={handleLogout} className={styles.bar} >
            <Typography className={styles.text}>{t('users.loginAsNormalUser')}</Typography>
        </div>
        }
        {!userData?.isAnonymous && (!userData || !userData.nationality || !userData.fullName || !userData.gender || !userData.phone)
            && <Grid xs={12} md={12} lg={12} xl={12} onClick={handleCompleteProfile} className={styles.bar}>
                <Typography style={{padding:"10px"}} className={styles.text}>{t('users.completeProfile')}</Typography>
            </Grid>
        }
    </>);
}

export default CompleteProfileHint